<template>
  <div
    v-html="require(`!!html-loader!./../../assets/icons/${icon}.svg`)"
    v-once
  ></div>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    width: { type: String, default: "40px" },
    height: { type: String, default: "40px" },
    custom: { type: Boolean, default: false },
  },
  mounted() {
    const svg = this.$el.querySelector("svg");
    svg.setAttribute("height", this.height);
    svg.setAttribute("width", this.width);

    if (!this.custom) {
      // Use default style if there is no explicitly specified "custom" attribute
      svg.classList.add(this.$style.default);
    }

    if (this.$vnode.data.staticClass) {
      // Applying component classes (if there are any) to the svg element
      svg.classList.add(...this.$vnode.data.staticClass.split(" "));
    }

    // Remove container div and render svg
    this.$el.outerHTML = this.$el.innerHTML;
  },
};
</script>

<style lang="scss" module>
svg {
  fill: currentColor;
}
.default {
  color: $primaryColor;
  &:hover {
    color: $primaryHoverColor;
  }
  &:active {
    color: $primaryOrange;
  }
}
</style>
